// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__kDuTZ","label":"CategoryService_label__1fBeM","location":"CategoryService_location__2Bbcy"};